import { getHashObj, setHash, stringIsValidDate } from "@/utils/utils"
import store from "@/vue/planning/store/store"
import { transportPacks } from "@/config/transportPackagePriorities"

export default {
	readUrl: ({ dispatch }) => {
		dispatch("refreshStateFromHash")

		const hash = window.location.hash.replace("#", "")

		// get hash values
		const hashObj = getHashObj(hash)

		// set hash in case it was changed here
		setHash(hashObj)
	},

	refreshStateFromHash: ({ commit, dispatch }) => {
		const hashStr = window.location.hash.replace("#", "")
		const hashObj = getHashObj(hashStr)

		if (hashObj["packCode"]) commit("setPackage", hashObj["packCode"])
		const beginDate = hashObj["BeginDate"]
		const endDate = hashObj["EndDate"]
		const origin = hashObj['origin']
		if (
			beginDate &&
			endDate &&
			stringIsValidDate(hashObj["BeginDate"]) &&
			stringIsValidDate(hashObj["EndDate"])
		) {
			commit("setStartDate", hashObj["BeginDate"])
			commit("setEndDate", hashObj["EndDate"])
			dispatch("refreshDataStoredOnWindow")
		}

		if(origin && transportPacks.includes(hashObj["packCode"])) {
			commit("setFlightOrigin", origin)
		}
		else {
			// If the origin is set and it is not a transport pack, set it to null
			commit("setFlightOrigin", null)
		}
	},

	checkActivePrestations: async({state, commit}) => {
		const hashStr = window.location.hash.replace('#', '')

		if (!hashStr.includes('activePrestations')) {
		  return
		}

			const params = new URLSearchParams(hashStr);
			const activePrestations = params.get('activePrestations');
	
			if (activePrestations) {
				try {
					const newActivePrestations = JSON.parse(activePrestations).map(prestId => prestId.toString());
					commit("setActivePrestations", newActivePrestations)

					// Step 1: Filter the Prestations displayed on the page to include only the relevant ones
					const filteredPrestations = state.initialPrestationsArray.filter(prestation =>
						state.activePrestations.includes(prestation.prestationId) 
					);

					// Step 2: Extract all prestationIds from initialPrestationsArray
					const existingIds = state.initialPrestationsArray.map(prestation => prestation.prestationId);

					// Step 3: Filter state.activePrestations for IDs not in existingIds
					const missingIds = state.activePrestations.filter(id => !existingIds.includes(id.toString()));
					
					if (missingIds.length === 0) {
						console.log('[DEBUG] No missing prestations.')
				
						// ✅ Ensure popup logic still works by committing filteredPrestations
						commit('setPrestationsFromCatalog', filteredPrestations)
					  }

					// Step 4: Create an array of promises, for the missingIds only 
					const prestFromCatalogPromises = missingIds.map(prestationId => {
						const requestData = {
						locale: store.getters.locale,
						prestationId,
						};
						return window.catalogService.getPrestationByLocale(requestData); // Returns a promise
					});

					// Step 5: Resolve all promises in parallel
					const results = await Promise.all(prestFromCatalogPromises);

					// Step 6: allActivePrestations will include:
					// - Prestations currently displayed on the page that are part of activePrestations.
					// - Prestations from activePrestations that are not yet displayed on the page (fetched from the catalog).
					const allActivePrestations = [...filteredPrestations,...results]

					// Step 7: sort allActivePrestations to match the order from state.activePrestations:
					// Reordering based on configArray
					const orderedArray = allActivePrestations.sort((a, b) => {
						const indexA = state.activePrestations.indexOf(a.prestationId);
						const indexB = state.activePrestations.indexOf(b.prestationId);
					
						// If prestationId is not found in configArray, move it to the end
						if (indexA === -1) return 1;
						if (indexB === -1) return -1;
					
						// Otherwise, sort based on the index in configArray
						return indexA - indexB;
					});
					
					commit("setPrestationsFromCatalog", orderedArray)
				} catch (error) {
					console.error('Error parsing activePrestations:', error);
				}
			}
		}
	}

